<template>
  <div class="time-registration">
    <div class="row">
      <div class="col-12 col-sm-4 text-center text-sm-start">
        <page-title :title="'Aanwezigheid'" icon="planning"></page-title>
      </div>
    </div>
    <div class="row">
      <div v-bind:key="child.id" v-for="child in sortChildren(children)" v-on:click="togglePresence(child)" class="col-12 col-sm-6 col-md-6 col-lg-4">
        <child-list-item :child="child" class="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import ChildListItem from '@/components/Child-List-Item'
export default {
  name: 'time-registration',
  components: {
    PageTitle,
    ChildListItem
  },
  created () {
    this.$store.dispatch('getChildren')
    this.$store.dispatch('getChildrenPresence')
  },
  methods: {
    sort (children, by) {
      by = by || this.getApplicationSetting('ipad_sort_children_by')
      if (by === false) {
        by = 'first_name'
      }
      return this.$lodash().sortBy(children, [child => child[by].toLowerCase()], 'asc')
    },
    togglePresence (child) {
      child = this.getChild(child.id_child) || child
      if (this.getChildIsPresent(child) === true) {
        // becomes false
        var presence = this.getChildPresence(child)
        this.$request.put('/presence/' + presence.id, {}
        ).then((response) => {
          if (response.data && response.data.id) {
            this.setChildPresent(child, response.data)
          }
        })
      } else if (this.getChildIsPresent(child) === false) {
        // becomes true
        var currentGroupId = this.getOneSelectedGroupId()
        if (currentGroupId === null) {
          alert('Kon de groep van het kind niet bepalen')
        }
        this.$request.post('/presence', {
          child_id: child.id,
          group_id: currentGroupId
        }).then((response) => {
          if (response.data && response.data.id) {
            this.setChildPresent(child, response.data)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
  .item {
    background: rgba(255, 255, 255, 0.5);
    padding: 20px;
    margin-bottom: 10px;
    cursor: pointer;
  }
</style>
